<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 col-lg-6 mt-5">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-lg-6 mt-md-5">
            <div>
              <!-- START SINGLEITEM_DETAILS -->
              <h1 class="h2 title" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
              </h1>

              <a href="#feedback-container" class="d-inline-block ml-n3 mb-3">
                <feedback-average :show-empty-ratings="false" size-of-stars="3" :show-ratings-amount="true"> </feedback-average>
              </a>

              <div class="d-flex flex-wrap justify-content-between mb-4">
                <div class="advantages" v-if="currentVariation.texts.technicalData !== ''">
                  <div>
                    <span class="font-weight-bold">Ihre Vorteile:</span>
                    <div v-html="currentVariation.texts.technicalData"></div>
                  </div>
                </div>
                <div class="emicode-siegel d-flex align-items-center">
                  <template v-for="variationPropertyGroup in currentVariation.variationProperties">
                    <template v-for="variationProperty in variationPropertyGroup.properties">
                      <template v-if="variationProperty.id == 17">
                        <a href="/emicode" target="_blank" :key="`emicode-${variationProperty.id}`">
                          <img :src="variationProperty.values.value" alt="Emicode Siegel" class="img-fluid mt-4 mt-md-0" :key="variationProperty.id" />
                        </a>
                      </template>
                    </template>
                  </template>
                </div>
              </div>

              <template v-for="variationPropertyGroup in currentVariation.variationProperties">
                <template v-for="variationProperty in variationPropertyGroup.properties">
                  <div class="application mb-4" v-if="variationProperty.id == 13" :key="`app-${variationPropertyGroup.id}-${variationProperty.id}`">
                    <div>
                      <span class="font-weight-bold">Einsatzgebiete:</span>
                      <template v-for="variationPropertyGroup2 in currentVariation.variationProperties">
                        <template v-for="variationProperty2 in variationPropertyGroup2.properties">
                          <template v-if="variationProperty2.id == 13">
                            <ul class="d-flex" :key="`list-${variationPropertyGroup2.id}-${variationProperty2.id}`">
                              <li v-for="(selects, index) in variationProperty2.values" :key="`select-${index}`">{{ selects.value }}</li>
                            </ul>
                          </template>
                        </template>
                      </template>
                    </div>
                  </div>
                </template>
              </template>

              <div class="danger-wrapper p-4 bg-gray mb-4" v-for="item in currentVariation.properties.filter((prop) => prop.propertyId === 60)" :key="`danger-${item.propertyId}-${item.id}`">
                <span class="font-weight-bold">Sicherheitshinweise für Gefahrenstoffe:</span>
                <div class="d-flex justify-content-between mt-2 flex-wrap">
                  <p class="add-data" v-for="item2 in currentVariation.properties.filter((prop) => prop.propertyId === 60)" :key="`add-data-${item2.id}`">{{ item2.texts.value }}</p>
                  <div class="picto d-flex justify-content-between">
                    <div v-for="item3 in currentVariation.properties.filter((prop) => prop.propertyId === 48)" :key="`picto-48-${item3.id}`">
                      <img v-for="(url, index) in item3.texts.value.split(',')" :key="`img-48-${item3.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                    </div>

                    <div v-for="item4 in currentVariation.properties.filter((prop) => prop.propertyId === 49)" :key="`picto-49-${item4.id}`">
                      <img v-for="(url, index) in item4.texts.value.split(',')" :key="`img-49-${item4.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                    </div>

                    <div v-for="item5 in currentVariation.properties.filter((prop) => prop.propertyId === 50)" :key="`picto-50-${item5.id}`">
                      <img v-for="(url, index) in item5.texts.value.split(',')" :key="`img-50-${item5.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                    </div>
                  </div>
                </div>

                <div class="danger-container">
                  <div class="mt-5">
                    <div v-for="prop in currentVariation.properties.filter((p) => p.propertyId === 54)" :key="`comp-a-${prop.id}`">
                      <h4>Hinweise Komponente A</h4>
                      <div class="danger-hints mt-4">
                        <div class="row mb-3 danger-pikto" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 48)" :key="`danger-pikto-48-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenpiktogramm</strong></div>
                          <div class="col-10 col-sm-8 mx-auto text-center">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 48)" :key="`span-48-${item2.id}`">
                              <img v-for="(url, index) in item2.texts.value.split(',')" :key="`img-48-${item2.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                            </span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 51)" :key="`signal-51-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Signalwort</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 51)" :key="`span-51-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 54)" :key="`danger-54-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenhinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 54)" :key="`span-54-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 57)" :key="`safety-57-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Sicherheitshinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 57)" :key="`span-57-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 60)" :key="`additional-60-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Zusätzliche Angaben</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 60)" :key="`span-60-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-5" v-for="prop in currentVariation.properties.filter((p) => p.propertyId === 55)" :key="`comp-b-${prop.id}`">
                      <h4>Hinweise Komponente B</h4>
                      <div class="danger-hints mt-4">
                        <div class="row mb-2 danger-pikto" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 49)" :key="`danger-pikto-49-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenpiktogramm</strong></div>
                          <div class="col-10 col-sm-8 mx-auto text-center">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 49)" :key="`span-49-${item2.id}`">
                              <img v-for="(url, index) in item2.texts.value.split(',')" :key="`img-49-${item2.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                            </span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 52)" :key="`signal-52-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Signalwort</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 52)" :key="`span-52-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 55)" :key="`danger-55-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenhinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 55)" :key="`span-55-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 58)" :key="`safety-58-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Sicherheitshinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 58)" :key="`span-58-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 61)" :key="`additional-61-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Zusätzliche Angaben</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 61)" :key="`span-61-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-5" v-for="prop in currentVariation.properties.filter((p) => p.propertyId === 56)" :key="`comp-c-${prop.id}`">
                      <h4>Hinweise Komponente C</h4>
                      <div class="danger-hints mt-4">
                        <div class="row mb-2 danger-pikto" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 50)" :key="`danger-pikto-50-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenpiktogramm</strong></div>
                          <div class="col-10 col-sm-8 mx-auto text-center">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 50)" :key="`span-50-${item2.id}`">
                              <img v-for="(url, index) in item2.texts.value.split(',')" :key="`img-50-${item2.id}-${index}`" class="danger-img mr-2 img-fluid d-inline-block" :src="url" />
                            </span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 53)" :key="`signal-53-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Signalwort</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 53)" :key="`span-53-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 56)" :key="`danger-56-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Gefahrenhinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 56)" :key="`span-56-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 59)" :key="`safety-59-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Sicherheitshinweise</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 59)" :key="`span-59-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                        <div class="row mb-2" v-for="item in currentVariation.properties.filter((p) => p.propertyId === 62)" :key="`additional-62-${item.id}`">
                          <div class="col-12 col-sm-4 mb-2 mb-sm-0"><strong>Zusätzliche Angaben</strong></div>
                          <div class="col-10 col-sm-8 mx-auto">
                            <span v-for="item2 in currentVariation.properties.filter((p) => p.propertyId === 62)" :key="`span-62-${item2.id}`">{{ item2.texts.value }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="descriptionToggle">
                  <button class="btn btn-link btn-inline-block text-dark text-decoration-none py-2 pl-0">
                    <span class="show-more">mehr anzeigen <i class="fa fa-chevron-down float-none text-dark small"></i></span>
                    <span class="show-less">weniger anzeigen <i class="fa fa-chevron-down float-none text-dark small"></i></span>
                  </button>
                </div>
              </div>

              <div class="buy-box p-4 bg-gray mb-4">
                <!-- Variation -->
                <div class="" v-if="attributes.length || Object.keys(units).length">
                  <variation-select></variation-select>
                </div>
                <!-- /Variation -->

                <!-- Item Bundle -->
                <item-bundle
                  v-if="currentVariation.variation.bundleType === 'bundle'"
                  :bundle-type="currentVariation.variation.bundleType"
                  :bundle-components="currentVariation.bundleComponents"
                ></item-bundle>
                <!-- /Item Bundle -->

                <slot name="before-price"></slot>

                <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                  <order-property-list></order-property-list>
                </div>

                <div class="name3" v-if="currentVariation.texts.name3 != 'N / A'">
                  <p class="mb-0">{{ currentVariation.texts.name3 }}</p>
                </div>

                <graduated-prices></graduated-prices>

                <hr />
                <ul class="static-usps list-unstyled d-flex flex-wrap justify-content-between">
                  <li class="d-flex align-items-center small font-weight-bold mb-3 mb-xl-0">
                    <i class="fa fa-check-circle-o mr-2" aria-hidden="true"></i>
                    <div>
                      <span class="d-flex">kostenlose Hotline</span>
                      <a href="tel:+4956122071080" class="text-dark"> +49 (0)561 220 710 80</a>
                    </div>
                  </li>

                  <li class="d-flex align-items-center small font-weight-bold mb-3 mb-xl-0">
                    <i class="fa fa-check-circle-o mr-2" aria-hidden="true"></i>
                    <div>
                      <span class="d-flex">kostenlose Rücklieferung</span>
                      <span>innerhalb Deutschlands</span>
                    </div>
                  </li>
                  <li class="d-flex align-items-center small font-weight-bold mb-0 mb-xl-0">
                    <i class="fa fa-check-circle-o mr-2" aria-hidden="true"></i>
                    <div>
                      <span class="d-flex">Guter Service</span>
                      <span>Gute Qualität</span>
                    </div>
                  </li>
                </ul>
                <hr />

                <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                <slot name="after-price"></slot>

                <item-availability></item-availability>

                <div class="my-3">
                  <div class="w-100">
                    <slot name="before-add-to-basket"></slot>
                  </div>

                  <span
                    v-if="currentVariation.item.id == 137 || currentVariation.item.id == 139 || currentVariation.item.id == 140 || currentVariation.item.id == 143"
                    class="alert alert-warning d-block w-100"
                  >
                    Dieses Produkt ist nicht an Privatpersonen lieferbar!
                  </span>

                  <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                  </div>
                  <div v-else class="col-12 px-0 my-3 basket-wrapper">
                    <add-to-basket
                      :variation-id="currentVariation.variation.id"
                      :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                      :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                      :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                      :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                      :maximum-quantity="
                        !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                      "
                      :order-properties="
                        currentVariation.properties.filter(function(prop) {
                          return prop.property.isOderProperty;
                        })
                      "
                      :has-order-properties="currentVariation.hasOrderProperties"
                      :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                      :use-large-scale="false"
                      :show-quantity="true"
                      :item-url="currentVariation | itemURL"
                      :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                      :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>

                  <div class="w-100">
                    <slot name="after-add-to-basket"></slot>
                  </div>
                </div>

                <!-- ./ITEM DETAIL -->

                <slot name="additional-content-after-add-to-basket"></slot>

                <slot name="additional-content-after-vat"></slot>
                <!-- END SINGLEITEM_DETAILS -->
              </div>
              <!-- Buybox End -->

              <div class="icons-wrapper d-flex justify-content-around">
                <img :src="$translate('easygroundVueTheme::SingleItemTheme.Icon1Image')" :alt="$translate('easygroundVueTheme::SingleItemTheme.Icon1Text')" class="img-fluid mb-3" />
                <img :src="$translate('easygroundVueTheme::SingleItemTheme.Icon2Image')" :alt="$translate('easygroundVueTheme::SingleItemTheme.Icon2Text')" class="img-fluid mb-3" />
                <img :src="$translate('easygroundVueTheme::SingleItemTheme.Icon3Image')" :alt="$translate('easygroundVueTheme::SingleItemTheme.Icon3Text')" class="img-fluid mb-3" />
                <img :src="$translate('easygroundVueTheme::SingleItemTheme.Icon4Image')" :alt="$translate('easygroundVueTheme::SingleItemTheme.Icon4Text')" class="img-fluid mb-3" />
                <img :src="$translate('easygroundVueTheme::SingleItemTheme.Icon5Image')" :alt="$translate('easygroundVueTheme::SingleItemTheme.Icon5Text')" class="img-fluid mb-3" />
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <!-- ITEM DESCRIPTION -->
            <div class="mt-0 mt-md-3 download-wrapper p-4 bg-gray build" v-if="downloadProperties.length">
              <div><h4 class="mb-3 mt-0">Downloads</h4></div>
              <div class="downloads">
                <div class="download mb-2 mr-2 d-inline-block" v-for="(prop, index) in downloadProperties" :key="index">
                  <a class="btn btn-dark text-white border-radius px-4" :href="prop.texts.value" :title="prop.property.names.name" target="_blank">
                    <span>{{ prop.property.names.name }}</span>
                  </a>
                </div>
              </div>
            </div>

            <div class="mt-5 mt-md-3 description">
              <span class="font-weight-bold mb-4">{{ $translate("Ceres::Template.singleItemDescription") }}</span>
              <div class="mb-4" v-html="currentVariation.texts.description"></div>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <div class="col-12 col-lg-6">
            <div class="fs-xselling mb-4 mt-0 mt-md-3">
              <slot name="cross-selling-accessory"></slot>
            </div>
            <div class="eu-respo mb-4 mt-0 mt-md-3">
              <p class="font-weight-bold mb-1" v-if="currentVariation.item.manufacturer.responsibleName != null">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</p>
              <div>
                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                  <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                  <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                  <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                    {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                  </span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                </div>
              </div>

              <div>
                <p class="font-weight-bold mb-1" v-if="currentVariation.item.manufacturer.name != null">{{ $translate("Ceres::Template.singleItemManufacturer") }}</p>
                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.name }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.street }}</span>
                  <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                  <span>{{ currentVariation.item.manufacturer.town }}</span>
                  <span v-if="currentVariation.item.manufacturer.countryObject">
                    {{ currentVariation.item.manufacturer.countryObject.name }}
                  </span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.email }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.url }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                </div>

                <div class="p-0">
                  <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="single page-content">
        <div
          class="container-fluid bg-gray py-5"
          v-if="currentVariation.item.id == 138 || currentVariation.item.id == 137 || currentVariation.item.id == 190 || currentVariation.item.id == 202 || currentVariation.item.id == 2824"
        >
          <div class="container-max">
            <div class="row video">
              <div class="col-12 col-md-6">
                <div>
                  <template v-for="variationPropertyGroup in currentVariation.variationProperties">
                    <template v-for="variationProperty in variationPropertyGroup.properties">
                      <template v-if="variationProperty.id == 12">
                        <div class="video-container" :key="`video-${variationPropertyGroup.id}-${variationProperty.id}`">
                          <div class="youtubevideo" :data-embed="variationProperty.values.value">
                            <!-- Play Button für den User -->
                            <div class="play-button"></div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-3 mt-md-0 d-flex flex-wrap align-items-center">
                <div>
                  <p class="h5 single_headline">Produktvideo</p>
                  <p class="h3 single_headline">{{ currentVariation | itemName }}</p>
                  <p>Wir zeigen dir wie unser Produkt ganz einfach verwenden kannst. Noch weitere hilfreiche Videos findest du <a href="/videos">hier</a>!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid bg-gray py-5" v-else>
          <div class="container-max">
            <div class="row video">
              <div class="col-12 col-md-6">
                <div>
                  <div data-embed="e32UAZoIeaM" class="youtubevideo">
                    <div class="play-button"></div>
                    <img src="https://img.youtube.com/vi/e32UAZoIeaM/maxresdefault.jpg" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-3 mt-md-0 d-flex flex-wrap align-items-center">
                <div>
                  <p class="h5 single_headline">Produktvideo</p>
                  <p class="h3 single_headline">Easy zum neuen Garagenboden</p>
                  <p>Noch weitere hilfreiche Videos findest du <a href="/videos">hier</a>!</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-max feed-item">
          <slot name="item-list-container"></slot>

          <feedback-container
            class="widget-inner"
            :options="{ allowFeedbacksOnlyIfPurchased: false, allowNoRatingFeedback: false, feedbacksPerPage: 10, numberOfFeedbacks: 1, timestampVisibility: true, allowGuestFeedbacks: true }"
            classes=""
            styles=""
            id="feedback-container"
          >
          </feedback-container>

          <div class="bg-box px-3 py-5">
            <div class="row mb-4">
              <div class="col-12 col-md-10 col-lg-8 mx-md-auto text-center">
                <p class="m-0 h1">FRAGEN &amp; ANTWORTEN</p>
                <p>
                  Wir freuen uns, dass Sie sich für unseren flüssigen Bodenbelag und das Zubehör interessieren. In unserem <a href="/faq">FAQ</a> haben wir zahlreiche Fragen zur Produktpalette und zur
                  Verwendung unserer Produkte zusammengetragen.
                </p>
              </div>
            </div>
            <div class="row font-heading px-3">
              <div class="col-12 col-md-4">
                <ul class="list-unstyled mb-0">
                  <li class="mb-2">Wo kann ich EASYGROUND anwenden?</li>
                  <li class="mb-2">Wie viel EASYGROUND benötige ich?</li>
                  <li class="mb-2">Muss ich den Boden vorbehandeln?</li>
                </ul>
              </div>
              <div class="col-12 col-md-4">
                <ul class="list-unstyled mb-0">
                  <li class="mb-2">Worauf hält EASYGROUND?</li>
                  <li class="mb-2">Was muss ich bei der Verarbeitung beachten?</li>
                </ul>
              </div>
              <div class="col-12 col-md-4">
                <ul class="list-unstyled mb-0">
                  <li class="mb-2">Kann ich EASYGROUND im Baumarkt kaufen?</li>
                  <li class="mb-2">Welche Gestaltungsmöglichkeiten gibt es mit EASYGROUND?</li>
                </ul>
              </div>
              <div class="col-12 text-center mt-4"><a href="/faq" class="btn btn-red">Zu den Fragen</a></div>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },
    downloadProperties() {
      if (!this.currentVariation || !this.currentVariation.properties) return [];
      return this.currentVariation.properties.filter((prop) => prop.group && prop.group.backendName === "Downloads");
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },
    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== "" ||
        this.currentVariation.item.manufacturer.externalName !== ""
      );
    },

    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },
    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
      this.toggleDescription();
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    getDataField(field) {
      return get(this.currentVariation, field);
    },

    toggleDescription() {
      $(".danger-wrapper #descriptionToggle span").on("click", (event) => {
        event.preventDefault();
        $(".danger-wrapper").toggleClass("show");
      });
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
